<div class="mt-0 mb-3">
    <dp-table [table]="table" [customStyles]="{'cssClass':'table table-hover'}" [heightScroll]="'45vh'"
        [selectable]="false" [disableTableSelectable]="disableTableSelectable" [showLoading]="showLoading">
    </dp-table>
</div>
